export default __webpack_public_path__ + "static/logo-ef-2a9494b4ab68c6fbad72b698e76e2aa7.png";